import { handleGetRequest } from "./http.service";

export interface PlacementWorker {
  _id: string;
  firstName: string;
  lastName: string;
  phoneNumber: string;
  email: string;
}

export interface PlacementAgency {
  _id: string;
  name: string;
}

export interface AdminPlacement {
  _id: string;
  worker: PlacementWorker;
  employer: { _id: string; firstName: string; lastName: string };
  agency: PlacementAgency;
  mynda: { _id: string; occupation: string[]; state: string; lga: string };
  salary: number;
  commissionAmount: number;
  status: string;
  startDate: string;
  endDate?: string;
  terminationReason?: string;
  notes?: string;
  createdAt: string;
}

export interface PlacementsResponse {
  page: number;
  limit: number;
  total: number;
  data: AdminPlacement[];
}

export const getAllPlacements = async (params?: {
  page?: number;
  limit?: number;
  status?: string;
}) => {
  const qs = new URLSearchParams();
  if (params?.page) qs.set("page", String(params.page));
  if (params?.limit) qs.set("limit", String(params.limit));
  if (params?.status) qs.set("status", params.status);
  const query = qs.toString() ? `?${qs}` : "";
  return handleGetRequest<PlacementsResponse>(`/placements/admin/all${query}`);
};
